import { Notifications } from '../../library/constants'

export default (
  autorollLogic,
  winAmount,
  betAmount,
  balance,
  sendBet,
  handleNotification,
  toFix,
  currency,
  maxStake,
  setisAutoOn
) => {
  // this.myTimeout = setTimeout(function () {
  const value = autorollLogic.nextStep(winAmount - betAmount)
  // console.log('autorollLogic.bet, balance', autorollLogic.bet, balance)
  if (+autorollLogic.bet > balance) {
    handleNotification(Notifications.notEnoughBalance)
    setisAutoOn(false)
    return
  }

  switch (value) {
    case autorollLogic.ROLL_OK:
      return sendBet(autorollLogic.bet)
    case autorollLogic.ROLL_STOP_ON_LOSS:
      handleNotification(
        Notifications.stoppedOnLoss +
          (+autorollLogic.ggr).toFixed(toFix) +
          currency
      )
      setisAutoOn(false)
      break
    case autorollLogic.ROLL_STOP_ON_WIN:
      handleNotification(
        Notifications.stoppedOnWin +
          (+autorollLogic.ggr).toFixed(toFix) +
          currency
      )
      setisAutoOn(false)
      break
    case autorollLogic.ROLL_STOP_ON_NUMBETS:
      setisAutoOn(false)
      handleNotification(Notifications.onSelectedNumberOfBets)
      break
    case autorollLogic.ROLL_STOP_ON_MAX_BET:
      handleNotification(Notifications.maxStake + maxStake + ' ' + currency)
      setisAutoOn(false)
      break
    default:
      // console.log('default')
      break
  }
}
